import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Snackbar, { SnackbarContext } from '@common/Snackbar';
import tracker from 'tracker';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import fdpHelper from './utils/FDPhelper';
import fdpHelperV2 from '@utils/FDPHelperV2';
import { enableFDPNativeV2 } from 'fk-cp-common-components/fdpTracking/FDPTrackingUtils';
import Drawer, { DrawerContext } from '@common/Drawer/v2';
import Dialog from '@common/Dialog/DialogV2.tsx';
import DialogContext from '@common/Dialog/DialogContext';
import Tooltip from '@common/Tooltip/Tooltip';
import TooltipAdapter from 'fk-cp-common-components/webComponents/V4/common/ToolTip/TooltipAdapter';
import ToolTipContext from 'fk-cp-common-components/webComponents/V4/common/ToolTip/ToolTipContext.js';
import StaticStoreWrapper from './components/RouteWrappers/StaticStoreWrapper';
import { shallowEqualExcludingKey } from 'fk-cp-common-components/utils/ShallowEquals';
import { trackRouteViewEvent } from 'fk-cp-common-components/utils/newRelicUtils';

let DwellTimeRouteTracker;
try {
	// eslint-disable-next-line @typescript-eslint/no-var-requires
	DwellTimeRouteTracker = require('./utils/dwell-time/DwellTimeRouteTracker').default;
} catch (e) {
	DwellTimeRouteTracker = null;
}

class App extends Component {
	getSnackbarContext = () => ({
		showSnackbar: props => this.snackbar && this.snackbar.showSnackbar(props),
		hideSnackbar: () => this.snackbar && this.snackbar.hideSnackbar()
	});

	getDialogContext = () => ({
		openDialog: (props) => this.dialog && this.dialog.show(props),
		closeDialog: () => this.dialog && this.dialog.hide()
	  });

	getDrawerContext = () => ({
		openDrawer: props => this.drawer && this.drawer.open(props),
		closeDrawer: () => this.drawer && this.drawer.close()
	});

	getToolTipContext = () => ({
		showToolTip: props => this.toolTip && this.toolTip.showToolTip(props),
		hideToolTip: () => this.toolTip && this.toolTip.hideToolTip()
	});

	getChildContext() {
		return {
			snackbar: this.getSnackbarContext(),
			drawer: this.getDrawerContext(),
			dialog: this.getDialogContext(),
			toolTip: this.getToolTipContext()
		};
	}

	UNSAFE_componentWillMount() {
		if (ExecutionEnvironment.canUseDOM) {
			try {
				tracker.init({
					rootMargin: '-85px 0px 0px 0px',
					batchCallback: fdpPendingEvents =>
						fdpPendingEvents.forEach(event => {
							if (enableFDPNativeV2 && enableFDPNativeV2()) {
								fdpHelperV2.trackEvent(event);
							} else {
								fdpHelper.trackEvent(event);
							}
						})
				});
			} catch (e) {
				// ignore error
			}
		}
	}
	componentDidMount() {
		trackRouteViewEvent('initial_route', window.location.pathname);
		window.addEventListener('beforeinstallprompt', function (e) {
			if (window.Notification && Notification && Notification.permission === 'default') {
				e.preventDefault();
			}
		});
		
		if (ExecutionEnvironment.canUseDOM && DwellTimeRouteTracker && typeof DwellTimeRouteTracker.initialize === 'function') {
			try {
				DwellTimeRouteTracker.initialize();
			} catch (e) {
				// eslint-disable-line no-empty
			}
		}
	}
	componentDidUpdate(prevProps) {
		// eslint-disable-next-line react/prop-types
		if (prevProps.children !== this.props.children) {
			this.dialog && this.dialog.hide();
			// eslint-disable-next-line react/prop-types
			const urlChanged = !shallowEqualExcludingKey(prevProps.location.query, this.props.location.query, 'isSummary');
			if (this.drawer.shouldDrawerCloseOnNavigation() && urlChanged) {
				this.drawer && this.drawer.close();
			}
		}
	}
	get debugger() {
		if (__CAN_DEBUG__) {
			// eslint-disable-next-line @typescript-eslint/no-var-requires
			const { DebuggerContainer, PreferenceForm } = require('rv-debugger');
			return (
				<DebuggerContainer>
					<PreferenceForm items={[{ label: 'MAPI-host', id: 'mapi_host', type: 'string' }]} />
				</DebuggerContainer>
			);
		}
		return null;
	}

	render() {
		return (
			<SnackbarContext.Provider value={this.getSnackbarContext()}>
				<DrawerContext.Provider value={this.getDrawerContext()}>
					<DialogContext.Provider value={this.getDialogContext()}>
						<ToolTipContext.Provider value={this.getToolTipContext()}>
								<TooltipAdapter ref={r => (this.toolTip = r)} TooltipComponent={Tooltip} />
								<Snackbar ref={r => (this.snackbar = r)} />
								<Drawer ref={r => (this.drawer = r)} />
								<Dialog ref={r => (this.dialog = r)} />
								<StaticStoreWrapper {...this.props} />
								{this.debugger}
							</ToolTipContext.Provider>
					</DialogContext.Provider>
				</DrawerContext.Provider>
			</SnackbarContext.Provider>
		);
	}
}
App.childContextTypes = {
	snackbar: PropTypes.object.isRequired,
	drawer: PropTypes.object.isRequired,
	dialog: PropTypes.object.isRequired,
	toolTip: PropTypes.object.isRequired
};

export default App;


